import { render, staticRenderFns } from "./PackageWaitingModal.vue?vue&type=template&id=9f278844&scoped=true&"
import script from "./PackageWaitingModal.vue?vue&type=script&lang=js&"
export * from "./PackageWaitingModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f278844",
  null
  
)

export default component.exports